<template>
  <div class="petAdmin">
    <div class="header acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1">{{ userInfo.real_name }}</div>
          </div>
        </div>
      </div>
			<span
			  class="iconfont icon-shezhi"
			  @click="$router.push({ path: '/petAdmin/cardConfig' })"
			></span>
    </div>
    <div class="wrapper">
      <div class="nav acea-row row-middle">
        <router-link :to="{ path: '/petAdmin/orderList/today' }" class="item">
          <div>今日订单</div>
          <div class="num">{{ userInfo.todayOrderCount || 0 }}</div>
        </router-link>
        <router-link :to="{ path: '/petAdmin/incomeList/today' }" class="item">
          <div>今日收益</div>
          <div class="num">{{ userInfo.todayOrderSum || 0.00 }}</div>
        </router-link>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
					<div class="item" :key="index" @click="goPages('deviceList')">
						<div class="pictrue">
							<img src="@assets/images/device.png" />
						</div>
						<div>设备列表</div>
					</div>
					<div class="item" :key="index" @click="goPages('orderList/all')">
						<div class="pictrue">
							<img src="@assets/images/order.png" />
						</div>
						<div>订单记录</div>
					</div>
					<div class="item" :key="index" @click="goPages('incomeList/all')">
						<div class="pictrue">
							<img src="@assets/images/income.png" />
						</div>
						<div>收益记录</div>
					</div>
					<div class="item" :key="index" @click="goPages('financeList')">
						<div class="pictrue">
							<img src="@assets/images/finance.png" />
						</div>
						<div>结算记录</div>
					</div>
					<div class="item" :key="index" @click="goPages('faultList')">
						<div class="pictrue">
							<img src="@assets/images/fault.png" />
						</div>
						<div>故障记录</div>
					</div>
					<div class="item" :key="index" @click="goPages('repairsList')">
						<div class="pictrue">
							<img src="@assets/images/repairs.png" />
						</div>
						<div>报修记录</div>
					</div>
					<div class="item" :key="index" @click="goPages('materialList')">
						<div class="pictrue">
							<img src="@assets/images/material.png" />
						</div>
						<div>物料记录</div>
					</div>
					<div class="item" :key="index" @click="goPages('notice')">
						<div class="pictrue">
							<img src="@assets/images/notice.png" />
						</div>
						<div>系统公告</div>
					</div>
				</div>
      </div>
    </div>
    <div class="footer-line-height"></div>
  </div>
</template>

<script>
import PetApi from "../../api/petAdmin";
import { isWeixin } from "@utils";
const NAME = "PetAdmin";
export default {
  name: NAME,
  components: {},
  props: {},
  data: function() {
    return {
      userInfo: {},
      isWeixin: false,
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {}
    }
  },
  mounted: function() {
		this.getInfo();
    this.isWeixin = isWeixin();
  },
  methods: {
    goPages: function(page) {
			// return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      this.$router.push({ path: "/petAdmin/" + page });
    },
		getInfo() {
			let that = this;
			PetApi.userInfo().then(
			  res => {
					that.userInfo = res.data;
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  },
			  300
			);
		}
  }
};
</script>

<style scoped>
.petAdmin .header{padding:0 0.3rem;height:1.9rem;position:relative;background-color: #F5A100;}
.petAdmin .header:after {position: absolute;left: 0;right: 0;bottom: -0.98rem;z-index: -1;content:'';height:1rem;width: 100%;
    border-radius: 0 0 50% 50%;background-color: #F5A100;}
.petAdmin .header .picTxt .pictrue{width:1.2rem;height:1.2rem;}
.petAdmin .header .picTxt .pictrue img{width:100%;height:100%;border-radius:50%;border:0.03rem solid #f5f5f5;}
.petAdmin .header .picTxt .text{width:4.34rem;color:rgba(255,255,255,1);margin-left:0.35rem;text-align:left;}
.petAdmin .header .picTxt .text .name{font-size:0.32rem;max-width:2.6rem;width:unset;}
.petAdmin .header .picTxt .text .member{padding:0 0.1rem;height:0.36rem;background-color:rgba(0, 0, 0, 0.2);font-size:0.2rem;
    border-radius:0.3rem;margin-left:0.17rem;}
.petAdmin .header .picTxt .text .member img{width:0.28rem;height:0.28rem;font-size:0.2rem;margin-right:0.08rem;}
.petAdmin .header .picTxt .text .id{color:rgba(255,255,255,0.6);font-size:0.26rem;margin-top:0.15rem;}
.petAdmin .header .picTxt .text .id .iconfont{font-size:0.3rem;margin-left:0.12rem;}
.petAdmin .header .icon-shezhi{font-size:0.36rem;color:#fff;margin-top:-0.52rem;}
.petAdmin .wrapper{padding:0 0.2rem;}
.petAdmin .wrapper .nav{background-color:#fff;border-radius:0.06rem;height:1.4rem;}
.petAdmin .wrapper .nav .item{flex:1;-webkit-flex:1;-o-flex:1;-ms-flex:1;text-align:center;font-size:0.26rem;color:#aaa;position:relative;}
.petAdmin .wrapper .nav .item~.item:after{position:absolute;content:'';left:0;width:1px;height:0.7rem;background-color:#eee;
top:50%;margin-top:-0.35rem;}
.petAdmin .wrapper .nav .item .num{margin-top:0.1rem;font-size:0.36rem;color:#282828;}
.petAdmin .wrapper .myOrder{background-color:#fff;border-radius:0.1rem;margin-top:0.15rem;}
.petAdmin .wrapper .myOrder .title,.petAdmin .wrapper .myService .title{height:0.88rem;padding:0 0.3rem;border-bottom:1px dashed #eee;
    font-size:0.3rem;color:#282828;}
.petAdmin .wrapper .myOrder .title .allOrder{font-size:0.26rem;color:#666;}
.petAdmin .wrapper .myOrder .title .allOrder .iconfont{font-size:0.25rem;margin-left:0.07rem;}
.petAdmin .wrapper .myOrder .orderState{height:1.6rem;}
.petAdmin .wrapper .myOrder .orderState .item{font-size:0.26rem;color:#454545;flex:1;-webkit-flex:1;-o-flex:1;-ms-flex:1;text-align:center;}
.petAdmin .wrapper .myOrder .orderState .item .pictrue{width:0.49rem;height:0.42rem;margin:0 auto 0.18rem auto;}
.petAdmin .wrapper .myOrder .orderState .item .pictrue img{width:100%;height:100%;}
.petAdmin .wrapper .myService{background-color:#fff;margin-top:0.15rem;border-radius:0.1rem;}
.petAdmin .wrapper .myService .serviceList{padding:0.08rem 0 0.27rem 0;}
.petAdmin .wrapper .myService .serviceList .item{width:25%;text-align:center;font-size:0.26rem;color:#333;margin-top:0.3rem;}
.petAdmin .wrapper .myService .serviceList .item .pictrue{width:0.52rem;height:0.52rem;margin:0 auto 0.16rem auto;}
.petAdmin .wrapper .myService .serviceList .item .pictrue img{width:100%;height:100%;}
.petAdmin .support{width:2.19rem;height:0.74rem;margin:0.54rem auto;display:block;}
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
</style>
